/**
 * Clients shown in the homepage "Trusted by" gold banner.
 * Append entries here as new clients come in.
 * Optional `font`: 'script' uses Allura; default is Fraunces.
 * Scrolling activates automatically once the list has more than 4 entries.
 */
export const TRUSTED_CLIENTS = [
  { name: 'Farmer Banks Helfrich' },
  { name: 'Strike After Dark', font: 'script' },
];

export const TRUSTED_CLIENTS_SCROLL_THRESHOLD = 4;
